module.exports = __webpack_public_path__ + "static/img/apply7.cb213fb8.png";